import { render, staticRenderFns } from "./ResultCount.vue?vue&type=template&id=10b6f7d3&"
import script from "./ResultCount.vue?vue&type=script&lang=js&"
export * from "./ResultCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports